import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import createStore from './application/core/createStore';

ReactDOM.render(
    <Provider store={createStore()}>
        <App />
    </Provider>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx